<div
  *ngIf="state.refinements?.length > 0 || state.editorRefinements?.length > 0"
  class="ais-CurrentRefinements-list catalog_currentRefinedValues"
>
  <ng-container *ngFor="let item of refinements">
    <div class="ais-CurrentRefinements-item" *ngIf="!item.shouldHide">
      <button
        class="ais-CurrentRefinements-button"
        (click)="refine(item)"
        [ngClass]="{'ais-CurrentRefinements-button--static': item.staticField}"
      >
        <!-- Specific cases -->
        <ng-container *ngIf="item.label === 'sold.sold_on'" i18n="@@CATALOG.FILTERS.SOLD.SHOW"
          >Show sold products</ng-container
        >
        <ng-container *ngIf="item.label === 'sold.sold_off'" i18n="@@CATALOG.FILTERS.SOLD.HIDE"
          >Hide sold products</ng-container
        >
        <ng-container *ngIf="item.attributeName === 'country'">{{
          (i18nData.getCountryFromIso(item.name) | async).name
        }}</ng-container>
        <ng-container *ngIf="item.label === 'stock_on'" i18n="@@DELIVERY_OPTS.EXPRESS">Express Delivery</ng-container>
        <ng-container *ngIf="item.attributeName === 'seller.isOfficialStore'" i18n="@@PRODUCT.DESCRIPTION.BRAND_STORE"
          >Brand Approved</ng-container
        >
        <ng-container
          *ngIf="item.label === 'dsEligibleCountries_off' || item.label === 'dsEligibleCountries_on'"
          i18n="@@CATALOG.FILTERS.DS"
          >Direct Shipping</ng-container
        >
        <ng-container *ngIf="item.attributeName === 'localCountries'">{{ marketingFilterLocal?.title }}</ng-container>
        <ng-container *ngIf="item.attributeName === 'editorPicks.dealEligible'">{{
          currentDeal?.localizedName
        }}</ng-container>
        <ng-container *ngIf="item.label === 'We love'">
          {{ item.label }}
        </ng-container>
        <!-- Default case -->
        <ng-container
          *ngIf="
            item.attributeName !== 'country' &&
            item.attributeName !== 'localCountries' &&
            item.attributeName !== 'editorPicks.dealEligible' &&
            item.attributeName !== 'seller.isOfficialStore' &&
            item.label !== 'sold.sold_on' &&
            item.label !== 'sold.sold_off' &&
            item.label !== 'stock_on' &&
            item.label !== 'dsEligibleCountries_off' &&
            item.label !== 'dsEligibleCountries_on' &&
            item.label !== 'We love'
          "
        >
          {{ item.label }}
        </ng-container>
      </button>
    </div>
  </ng-container>

  <div class="catalog_currentRefinedValues__alert"><ng-content></ng-content></div>

  <button
    *ngIf="toggleClearBtn()"
    class="ais-CurrentRefinements-reset"
    (click)="clearAll()"
    i18n="@@CATALOG.FILTERS.CLEAR"
  >
    Clear filters
  </button>
</div>
